module.exports = __webpack_public_path__ + "d23f1988f4d88af531893f0dc8c75ce5.png";